import React from 'react';

/** Fallback invisível — evita spinner ao navegar entre rotas lazy (admin). */
export default function RouteLoadingFallback() {
  return null;
}
